import teeth from '@/assets/dashboard_teeth.png';

/**
 * The design's right-hand rail: a 270px gradient panel with the photo.
 *
 * It used to carry the estate's four headline totals as well. Those moved to
 * `OverviewStats` at the top of the main column, so this is now decoration.
 *
 * ── Why it bleeds past the content area ─────────────────────────────────────
 *
 * The design gives it `margin:-22px -24px -40px 0` - exactly the shell's
 * content padding, negated on three sides - so the panel runs to the top,
 * right and bottom edges of the viewport while the columns beside it keep their
 * gutter. That is what makes it read as part of the window rather than as a
 * very tall card, and it is the reason for the negative margins here.
 *
 * Hidden below xl. At that width the rail would squeeze the cards that matter.
 *
 * ── The photo ────────────────────────────────────────────────────────────
 *
 * `dashboard_teeth.png`, positioned exactly as the design canvas has it: an
 * absolutely-positioned `object-cover` image filling the panel, offset
 * `left:4px;top:-96px` and cropped to `object-position:center 18%` so the
 * framing lands the same way at 270px wide regardless of the photo's own
 * aspect ratio. `overflow-hidden` on the panel is what clips the offset
 * rather than letting it spill past the rail's edges.
 */
export function OverviewRail() {
  return (
    <aside className="relative -mt-5.5 -mr-6 -mb-10 hidden w-[270px] flex-none flex-col overflow-hidden bg-linear-[135deg,var(--color-brand-400),var(--color-brand-600)] xl:flex">
      <img
        src={teeth}
        alt=""
        aria-hidden="true"
        className="absolute h-full w-full object-cover object-[center_18%] opacity-95"
        style={{ left: '4px', top: '-96px' }}
      />
    </aside>
  );
}
